var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","color":"transparent"}},[_c('v-card-text',{staticClass:"pt-0"},[_vm._t("cardContent")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }